const foldList = {
  join: [
    {
      title: `{{$t("header.join")}}`,
      list: ['{{$t("header.about.index")}}', '人才理念', '岗位招聘', '招聘声明',
        {'title': '企业文化', 'path': '/join'}
      ]
    }
  ],
  news: [
    {
      title: '新闻动态',
      list: ['2018', '2017', '2016', '2015']
    }
  ]
}

export default foldList



// WEBPACK FOOTER //
// ./src/assets/js/fold.js